/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import Recommended from 'lib/@waca/vis-recommender/src/js/recommended/Recommended';
import VisTypeContainer from 'lib/@waca/vis-type-picker/src/js/VisTypeContainer';
import StringResources from 'nls/StringResources';
import { isExtVis } from '../../util/ExtVisUtil';

import './visTypeChooser.scss';

class VisTypeChooser extends Component {
	constructor(props) {
		super(props);

		this.visTypeExcludeChartIds = ['dataPlayer'];
		this.visTypeClassName = 'create-exploration__vis-type-picker-container';
		this.logger = props.services.biGlass.glassContext.getCoreSvc('.Logger');
		this.visDefinitions = this.props.dashboardApi.getFeature('VisDefinitions').getList();
	}

	render() {
		return (
			<div className='vis-recommender-explore__vis-recommender-picker'>
				{this.props.recommendationVM && this._renderRecommended()}
				<div className='vis-recommender-explore__vis-type-picker'>
					{this._renderVisTypePicker()}
				</div>
			</div>
		);
	}

	/**
	 * Render the vis type picker panel.
	 */
	_renderVisTypePicker() {
		return (
			<VisTypeContainer
				onVisTypeSelected={(visTypeId) => this.props.onVisTypeSelected(visTypeId)}
				services={this.props.services}
				filter={this.visTypeExcludeChartIds}
				visTypeClassName={this.visTypeClassName}
				selectedVisId={this.props.selectedVisId}
				isVizTypeLocked={this.props.isVizTypeLocked}
				isExtVis={isExtVis}
				visDefinitions={this.visDefinitions}
				iconsFeature={this.props.dashboardApi.getFeature('Icons')}
			/>
		);
	}

	_renderRecommended() {
		return (
			<div>
				<div className="vis-recommender-explore__title">
					{StringResources.get('recommended_visualizations')}
				</div>
				<div className="vis-recommender-explore__content">
					<Recommended
						isVizTypeLocked={this.props.isVizTypeLocked}
						dashboardApi={this.props.dashboardApi}
						recommendationVM={this.props.recommendationVM}
						onClickItem={this.props.onRecommendationSelected}
						additionalProperties={this.props.additionalProperties}
						selectedVisId={this.props.selectedVisId}
						logger={this.logger}
					/>
				</div>
			</div>
		);
	}
}

VisTypeChooser.propTypes = {
	services: PropTypes.object.isRequired,
	dashboardApi: PropTypes.object.isRequired,
	recommendationVM: PropTypes.object,
	isVizTypeLocked: PropTypes.bool,
	selectedVisId: PropTypes.string,
	onRecommendationSelected: PropTypes.func,
	onVisTypeSelected: PropTypes.func,
	additionalProperties: PropTypes.arrayOf(PropTypes.object),
	recommendFilters: PropTypes.array
};
VisTypeChooser.defaultProps = {
	onRecommendationSelected: () => {},
	onVisTypeSelected: () => {},
	additionalProperties: []
};
export default VisTypeChooser;



// WEBPACK FOOTER //
// ./src/js/components/visTypeChooser/VisTypeChooser.js